/* eslint-disable no-useless-escape */
const NumberHelpers = require("number_helpers");
// import { insertInImgUrl } from "util/number";
// import { rdcImgSm, rdcImgLg } from "util/imageFormat";
// import { removeHttpImageUrl } from "util/photo";
import config from "lib/config";
import { decompress } from "lib/context/UserContext/utils";
const ratemyagentlogo = `${config.CDN_PREFIX}/static/assets/images/ratemyagent-logo.png`;
const realsatisfiedlogo = `${config.CDN_PREFIX}/static/assets/images/realsatisfied-logo.png`;
const realtorlogo = `${config.CDN_PREFIX}/static/assets/images/realtor-logo.png`;
const testimonialtreelogo = `${config.CDN_PREFIX}/static/assets/images/testimonialtree-logo.png`;
const rdcpixLibrary = require("@inneropensource/rdcpix-library");

function agentSocialMediaDetails(profileData) {
  let socialMediaArr = [];
  let media = [];
  const social_connections = profileData && profileData.social_connections;
  const social_media = profileData && profileData.social_media;
  if (social_connections) {
    if (
      social_connections.blog_rss &&
      social_connections.blog_rss.settings &&
      social_connections.blog_rss.settings.show_link == true &&
      social_connections.blog_rss.link
    ) {
      socialMediaArr.push({ type: "BLOG", link: social_connections.blog_rss.link });
      media.push("BLOG");
    }
    if (
      social_connections &&
      social_connections.twitter &&
      social_connections.twitter.settings &&
      social_connections.twitter.settings.show_link == true &&
      social_connections.twitter.link
    ) {
      socialMediaArr.push({ type: "twitter", link: social_connections.twitter.link });
      media.push("twitter");
    }
    if (social_connections.facebook && social_connections.facebook.pages) {
      let pages = social_connections.facebook.pages;
      pages = pages && pages.filter((page) => page.settings.show_link === true);
      const link = pages && pages.length > 0 && pages[0] ? pages[0].link : "";
      socialMediaArr.push({ type: "facebook", link });
      media.push("facebook");
    }
  }
  if (social_media) {
    social_media.map((social) => {
      if (
        social.type == "BLOG" &&
        social.href &&
        social_connections &&
        social_connections.blog_rss &&
        social_connections.blog_rss.settings &&
        !media.includes("BLOG")
      ) {
        if (social_connections.blog_rss.settings.show_link == true) {
          socialMediaArr.push({ type: "BLOG", link: social.blog_rss.link });
          media.push("BLOG");
        }
      } else if (social.type == "BLOG" && social.href && !media.includes("BLOG")) {
        socialMediaArr.push({ type: "BLOG", link: social.href });
        media.push("BLOG");
      }
      if (
        social.type == "twitter" &&
        social.href &&
        social_connections &&
        social_connections.twitter &&
        social_connections.twitter.settings &&
        !media.includes("twitter")
      ) {
        if (social_connections.twitter.settings.show_link == true) {
          socialMediaArr.push({ type: "twitter", link: social.href });
          media.push("twitter");
        }
      } else if (social.type == "twitter" && social.href && !media.includes("twitter")) {
        socialMediaArr.push({ type: "twitter", link: social.href });
        media.push("twitter");
      }
      if (
        social.type == "facebook" &&
        social.href &&
        social_connections &&
        social_connections.facebook &&
        social_connections.facebook.pages &&
        !media.includes("facebook")
      ) {
        const pages = social_connections.facebook.pages;
        const page_arr = pages.filter((page) => page.settings.show_link == true);
        if (page_arr && page_arr.length > 0 && !page_arr[0].link) {
          socialMediaArr.push({ type: "facebook", link: social.href });
          media.push("facebook");
        }
      } else if (social.type == "facebook" && social.href && !media.includes("facebook")) {
        socialMediaArr.push({ type: "facebook", link: social.href });
        media.push("facebook");
      }
    });
  }

  return socialMediaArr;
}

function agentSocialMediaFAR(socialMedia) {
  let socialMediaArr = [];

  if (socialMedia && socialMedia["facebook"] && socialMedia && socialMedia["twitter"]) {
    const fbLink = socialMedia["facebook"] && socialMedia["facebook"].href;
    const twitterlink = socialMedia["twitter"] && socialMedia["twitter"].href;
    socialMediaArr.push({ type: "facebook", link: fbLink }, { type: "twitter", link: twitterlink });
  } else if (socialMedia && socialMedia["facebook"]) {
    const fbLink = socialMedia["facebook"] && socialMedia["facebook"].href;
    socialMediaArr.push({ type: "facebook", link: fbLink });
  } else if (socialMedia && socialMedia["facebook"]) {
    const twitterlink = socialMedia["twitter"] && socialMedia["twitter"].href;
    socialMediaArr.push({ type: "twitter", link: twitterlink });
  }

  return socialMediaArr;
}
function eventFire(el, etype) {
  if (el && el.fireEvent) {
    el.fireEvent("on" + etype);
  } else {
    var evObj = document.createEvent("Events");
    evObj.initEvent(etype, true, false);
    el && el.dispatchEvent(evObj);
  }
}

function getMemberId(rememberCookie) {
  var cookieParts = rememberCookie.split("&");
  var regID = cookieParts.filter(function(cookiePart) {
    return cookiePart.indexOf("regID=") > -1;
  });
  var memberId = regID[0].split("=")[1];

  return { memberId };
}

const getSourceHeight = (sourceId) => {
  const rating_source_id = {
    RS: 22,
    LNKDIN: 0,
    TT: 22,
    QSC: 0,
    RDC: 17,
    RMA: 27,
  };
  const sourceValue = rating_source_id[sourceId];
  return sourceValue;
};

const getSourceWidth = (sourceId) => {
  const rating_source_id = {
    RS: 111,
    LNKDIN: 0,
    TT: 116,
    QSC: 0,
    RDC: 90,
    RMA: 98,
  };
  const sourceValue = rating_source_id[sourceId];
  return sourceValue;
};

const getRatingSource = (sourceId) => {
  const rating_source_id = {
    RS: realsatisfiedlogo,
    LNKDIN: "",
    TT: testimonialtreelogo,
    QSC: "",
    RDC: realtorlogo,
    RMA: ratemyagentlogo,
  };
  const sourceValue = rating_source_id[sourceId];
  return sourceValue;
};
const getRecommendationSource = (sourceId) => {
  const recommendations_source_id = {
    RS: "RealSatisfied",
    LNKDIN: "LinkedIn",
    TT: "Testimonial Tree",
    QSC: "RatedAgent",
    RDC: "Realtor.com",
  };
  const sourceValue = recommendations_source_id[sourceId];
  return sourceValue;
};

const getAgentPhoneNumber = (agentdetail, removeBrackets, pageType = "") => {
  let officenumber = "";
  if (pageType && pageType !== "") {
    officenumber =
      agentdetail && agentdetail.phones && agentdetail.phones.length > 0
        ? agentdetail.phones[0].number
        : "";
  } else {
    officenumber =
      agentdetail &&
      agentdetail.agent_bio &&
      agentdetail.agent_bio.phones &&
      agentdetail.agent_bio.phones.length > 0
        ? agentdetail.agent_bio.phones[0].number
        : "";
  }
  if (!officenumber) return "";
  officenumber = checkTollFreeNumber(officenumber);
  if (!removeBrackets) {
    officenumber = officenumber && officenumber.replace(/[^+\d]+/g, "");
  }
  return officenumber;
};

const checkTollFreeNumber = (officenumber) => {
  let modifiedOfficeNumber;
  modifiedOfficeNumber = officenumber && officenumber.replace(/[^+\d]+/g, "");
  if (modifiedOfficeNumber && modifiedOfficeNumber.length == 11) {
    modifiedOfficeNumber = modifiedOfficeNumber.substring(1);
  } else {
    modifiedOfficeNumber = officenumber;
  }
  modifiedOfficeNumber = NumberHelpers.number_to_phone(modifiedOfficeNumber, { area_code: true });
  return modifiedOfficeNumber;
};
const checkSpecializationTextLongLength = (specializations) => {
  let isLongLength = false;
  specializations &&
    specializations.forEach((specialization) => {
      if (specialization && specialization.name && specialization.name.length > 14) {
        isLongLength = true;
      }
    });
  return isLongLength;
};

const fetchLatLog = (hestiaData) => {
  let defaultCenter = null;
  if (!hestiaData) return null;
  Object.keys(hestiaData).map((recordType) => {
    if (hestiaData[`${recordType}`] && hestiaData[`${recordType}`].total && !defaultCenter) {
      hestiaData[`${recordType}`].results.map((record) => {
        if (defaultCenter) {
          return;
        }
        defaultCenter =
          record.location.address && record.location.address.coordinate
            ? {
                lat: record.location.address.coordinate.lat,
                lng: record.location.address.coordinate.lon,
              }
            : null;
      });
    }
  });
  return defaultCenter;
};

function checkFaceBookSettings(pages) {
  for (var i = 0; i < pages.length; i++) {
    let page = pages[i];

    if (page.access_token && page.id && page.settings && page.settings.show_stream === true) {
      const showStreamSetting = true;
      return showStreamSetting;
    }
  }
}
function canShowSocialMedia(profileData) {
  const faceBookDataIsThere =
    profileData &&
    profileData.social_connections &&
    profileData.social_connections.facebook &&
    profileData.social_connections.facebook.pages &&
    Array.isArray(profileData.social_connections.facebook.pages) &&
    profileData.social_connections.facebook.pages.length > 0 &&
    checkFaceBookSettings(profileData.social_connections.facebook.pages);

  const twitterDataIsThere =
    profileData &&
    profileData.social_connections &&
    profileData.social_connections.twitter &&
    profileData.social_connections.twitter.name;
  const blogPostDataIsThere =
    profileData &&
    profileData.social_connections &&
    profileData.social_connections.blog_rss &&
    profileData.social_connections.blog_rss.rss;
  let canShowSocialMediaStatus = faceBookDataIsThere || twitterDataIsThere || blogPostDataIsThere;
  canShowSocialMediaStatus = canShowSocialMediaStatus ? true : false;
  return canShowSocialMediaStatus;
}

const getAdvertiserIdandAgents = (agentDetails, team, isDecompress = false) => {
  let advertiserIds = [],
    agents = [];
  if (team) {
    advertiserIds =
      agentDetails &&
      agentDetails.team_members &&
      agentDetails.team_members.map((agent) => {
        return agent.advertiser_id;
      });
    let allMls = [],
      allMlsHistory = [];
    agentDetails &&
      agentDetails.team_members &&
      agentDetails.team_members.map((agent) => {
        allMls = allMls.concat(agent.mls);
      });
    agentDetails &&
      agentDetails.team_members &&
      agentDetails.team_members.map((agent) => {
        if (agent.mls_history && agent.mls_history.length) {
          allMlsHistory = allMlsHistory.concat(agent.mls_history);
        }
      });
    allMls = allMls.concat(allMlsHistory);
    const uniqueMls = allMls.filter(function(a) {
      var key = !isDecompress
        ? a.abbreviation + "|" + a.member.id
        : decompress(a.abbreviation) + "|" + decompress(a.member.id);
      if (!this[key]) {
        this[key] = true;
        return true;
      }
    }, Object.create(null));
    agents = uniqueMls.map((agent) => {
      return !isDecompress
        ? { id: agent.abbreviation, agent_id: agent.member.id }
        : { id: decompress(agent.abbreviation), agent_id: decompress(agent.member.id) };
    });
  } else {
    advertiserIds.push(agentDetails.agent_bio.advertiser_id);
    let allMls =
      agentDetails && agentDetails.agent_bio && agentDetails.agent_bio.mls
        ? agentDetails.agent_bio.mls
        : [];
    const allMlsHistory =
      agentDetails && agentDetails.agent_bio && agentDetails.agent_bio.mls_history
        ? agentDetails.agent_bio.mls_history
        : [];
    allMls = allMls.concat(allMlsHistory);
    const uniqueMls = allMls.filter(function(a) {
      var key = !isDecompress
        ? a.abbreviation + "|" + a.member.id
        : decompress(a.abbreviation) + "|" + decompress(a.member.id);
      if (!this[key]) {
        this[key] = true;
        return true;
      }
    }, Object.create(null));
    agents = uniqueMls.map((agent) => {
      return !isDecompress
        ? { id: agent.abbreviation, agent_id: agent.member.id }
        : { id: decompress(agent.abbreviation), agent_id: decompress(agent.member.id) };
    });
  }
  return { advertiserIds, agents };
};

const getHeastiaCallBodyData = (agentdetail, isDecompress = false) => {
  const agentBio = agentdetail && agentdetail.agent_bio;
  const { settings } = agentBio;
  const type = settings && !settings.display_sold_listings ? "settingsBased" : "all";
  const advertiser_id = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.advertiser_id;
  let advertiserId, agents;
  if (agentBio && advertiser_id) {
    let team = false;
    if (agentdetail && agentdetail.team) {
      team = true;
    }
    const agentAndAdvertiserIds = getAdvertiserIdandAgents(agentdetail, team, isDecompress);
    advertiserId = agentAndAdvertiserIds.advertiserIds;
    agents = agentAndAdvertiserIds.agents;
  }
  return { advertiserIdHestia: advertiserId || [], agents: agents || [], type };
};

const getaAgenthref = (selectedType, agentData, emptyImage) => {
  let imgUrlCode = "FAR_TEAM_PROFILE"; //team
  let photohref = agentData?.photo?.href;

  switch (selectedType) {
    case "company":
      imgUrlCode = "FAR_AGENT_STICKY_HEADER";
      break;
    case "agent":
      imgUrlCode =
        agentData?.photo?.is_zoomed === false
          ? "AGENT_AVATAR_SMALL"
          : "AGENT_PROFILE_SMALL_CROPPED";
      break;
  }

  // photohref = photohref && photohref.split("://")[1];
  // photohref = photohref && "//" + photohref;

  // let agenthref = photohref
  //   ? /avatar.svg/.test(photohref)
  //     ? insertInImgUrl(photohref)
  //     : insertInImgUrl(photohref, imgUrlCode, 4)
  //   : emptyImage;
  // agenthref=photohref?agenthref.replace(".jpg",".webp"):emptyImage;
  const updatedRdcpixHref = photohref ? generateRdcPixURL(photohref, imgUrlCode) : emptyImage;
  return updatedRdcpixHref;
};
const generateRdcPixURL = (url, sizeParam) => {
  const libraryUpdate = rdcpixLibrary.updateURLWithSize(url, sizeParam);
  let updatedUrl = libraryUpdate.href;
  let infoBlock = libraryUpdate.info;
  if (url && url.includes("http://") && infoBlock?.filetype) {
    updatedUrl = rdcpixLibrary.getUpdatedUrl(infoBlock, "https", sizeParam);
  }
  if (infoBlock?.filetype === "jpg" || infoBlock?.filetype === "jpeg") {
    updatedUrl = rdcpixLibrary.updateURLFiletype(updatedUrl, "webp");
  }
  return updatedUrl;
};
export {
  agentSocialMediaDetails,
  agentSocialMediaFAR,
  eventFire,
  getMemberId,
  getRatingSource,
  getRecommendationSource,
  getAgentPhoneNumber,
  checkSpecializationTextLongLength,
  fetchLatLog,
  checkTollFreeNumber,
  canShowSocialMedia,
  getAdvertiserIdandAgents,
  getHeastiaCallBodyData,
  getaAgenthref,
  getSourceHeight,
  getSourceWidth,
  generateRdcPixURL,
};
